import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import LoaderContext from '../../../../../context/LoaderContext';
// import useCreate from '../../../../../hooks/useCreate';
import useUpdate from '../../../../../hooks/useUpdate';
import LoadMask from '../../../../Utils/LoadMask/LoadMask';
import HolidayForm from './HolidayForm';
import dayjs from 'dayjs';

const CreateUpdate = () => {
    const location = useLocation();
    const { loader } = useContext(LoaderContext);
    const { data, title, update, updateData } = useUpdate(
        'holiday',
        '/calendar/holiday'
    );
    const isViewed = location.pathname.includes('view');
    // const { saveData } = useCreate('product', '/inventory/product_kit');
    const onSubmit = (dataForm) => {
        const body = { ...dataForm };
        body.date = dayjs(body.date).format('YYYY-MM-DD');
        const holy_day = body.id;
        updateData(body, holy_day);
    };
    return (
        <React.Fragment>
            <LoadMask loading={loader} blur>
                <div className="py-5">
                    <h1 className="title-2 cl-orange">
                        {/*isViewed ? 'Ver' : title*/} Artículo
                    </h1>
                    <HolidayForm
                        productData={data}
                        onSubmit={onSubmit}
                        view={isViewed}
                        update={update}
                    />
                </div>
            </LoadMask>
        </React.Fragment>
    );
};

export default CreateUpdate;
